module.exports = __webpack_public_path__ + "img/app_logo.47c3d593.svg";